function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoHtc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "Logo-HTC_svg__htc-logo",
  "data-name": "Ebene 1",
  viewBox: "0 0 165.435 54.522"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M108 21.3H88v33.2h-8.7V21.3h-20v-8.6H108zM32.6 13h-16a16.5 16.5 0 0 0-8 2.1V0H0v54.5h8.6V29.6a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v25h8.6v-25a16.7 16.7 0 0 0-16.6-16.7zm132.8 32.9a8 8 0 0 1-1.8.2h-30.8a8 8 0 0 1-8-8v-8.4a8 8 0 0 1 8-8h30.8a8 8 0 0 1 1.8.2V13a17 17 0 0 0-1.8 0h-30.8a16.5 16.5 0 0 0-16.6 16.5V38a16.5 16.5 0 0 0 16.6 16.5h30.8a17 17 0 0 0 1.8 0z",
  style: {
    fill: "#8bc04c"
  }
}));
export default SvgLogoHtc;